
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Phone, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="w-[800px] h-[600px] bg-gray-100 overflow-hidden">
      {/* Main Content */}
      <div className="flex items-center justify-center p-6 h-full">
        <div className="w-full max-w-md">
          <div className="bg-white rounded-2xl shadow-xl border border-gray-200 p-6 text-center">
            <div className="w-12 h-12 bg-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-3">
              <Phone className="w-6 h-6 text-white" />
            </div>
            <h1 className="text-xl font-bold text-gray-900 mb-2">Page Not Found</h1>
            <p className="text-gray-600 mb-4 text-sm">
              The page you're looking for doesn't exist or has been moved.
            </p>
            <Button
              onClick={() => navigate('/')}
              className="bg-blue-600 hover:bg-blue-700 rounded-full"
              size="sm"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
